import React, { PropTypes } from 'react'
import { FormattedDate, intlShape } from 'react-intl'
import * as shapes from '../../../constant/shapes'
import { Link } from 'react-router'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../../components/miniPlayer/AudioPlayer/playerConstants'
import MiniPlayer from '../../../components/miniPlayer/MiniPlayer'
import hiResLogo from "../../../resources/img/logo-hires.png"
import cx from "classnames"

const StoryAlbumCard = (props, context) => {
  const { album, forceCardHeight, forceImageHeight, current, playing, GTMPlayEvent } = props
  const { intl } = context

  return (
    <article
      className={`card ${current ? (playing ? 'isPlaying' : 'isPause') : ''}`}
      style={forceCardHeight ? { height: forceCardHeight } : {}}
    >
      <div className="card__container">
        <img
          className="card__image"
          src={album.image || ''}
          alt=""
          height="295"
          width="295"
          style={forceImageHeight ? { height: forceImageHeight } : {}}
        />
        <div className="card__action">
          <div className="card__infos">
            <span className="card__genre">{intl.formatMessage({ id: `genre.genre-id-${album.genre}` })}</span>
            {album.release_date_original && <span className="card__date">
              <FormattedDate
                value={new Date(`${album.release_date_original}T00:00:00`)}
                day="numeric"
                month="short"
                year="numeric"
              />
            </span>
            }
          </div>

          <Link className="card__linker" to={`/album/${album.id}`} />

          <MiniPlayer
            buttonClassName="card__button"
            element={album}
            type={ORIGIN_PLAYQUEUE_TYPES.album}
            GTMPlayEvent={GTMPlayEvent}
            sampleable={album.sampleable}
          />
        </div>
      </div>
      <div className={cx("card__meta", { "card__meta--no-hires": !album.hires })}>
        <h3 className="card__title" title={album.title}>
          <Link className="card__link" to={`/album/${album.id}`}>{album.title}</Link>
        </h3>
        {album.artist &&
          <p className="card__subtitle" title={album.artist.name}>
            <Link className="card__link" to={`/artist/${album.artist.id}`}>{album.artist.name}</Link>
          </p>
        }
        {album.hires &&
          <img className="card__quality" src={hiResLogo} alt={intl.formatMessage({ id: 'infos.hires' })} height="40" width="40" />
        }
      </div>

    </article>
  )
}

StoryAlbumCard.propTypes = {
  album: shapes.albumCard,
  forceCardHeight: PropTypes.number,
  forceImageHeight: PropTypes.number,
  current: PropTypes.bool,
  playing: PropTypes.bool,
  GTMPlayEvent: PropTypes.string
}

StoryAlbumCard.contextTypes = {
  intl: intlShape
}

export default StoryAlbumCard



// WEBPACK FOOTER //
// ./src/pages/story/subComponents/StoryAlbumCard.jsx